import React from 'react';
import MDBox from '../../atoms/MDBox';
import MDTypography from '../../atoms/MDTypography';
import LoadingSpinner from '../../atoms/LoadingSpinner';
import { COMMON_TEXTS } from '../../../../utils/texts';

export interface LoadingStateProps {
  message?: string;
  variant?: 'h6' | 'body1' | 'body2';
  padding?: number;
  spinnerSize?: number;
  minHeight?: string | number;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = COMMON_TEXTS.loading,
  variant = 'h6',
  padding = 3,
  spinnerSize = 60,
  minHeight = '200px'
}) => {
  return (
    <MDBox 
      p={padding}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={minHeight}
    >
      <MDBox mb={2}>
        <LoadingSpinner size={spinnerSize} />
      </MDBox>
      <MDTypography variant={variant}>
        {message}
      </MDTypography>
    </MDBox>
  );
};

export default LoadingState;